import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PurchaseProductService } from '../../../purchase/services/purchase-product.service';
import { RepurchaseProductService } from '../../../repurchase/services/repurchase-product.service';
import { ConsignmentProductService } from '../../../consignment/services/consignment-product.service';

import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';

@Component({
  selector: 'app-list-product',
  templateUrl: './list-product.component.html',
  styleUrls: ['./list-product.component.css'],
  providers:[ProductService, PurchaseProductService,RepurchaseProductService,ConsignmentProductService]
})
export class ListProductComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  products: any = [];
  filters:any = {
    description:{contains: ""},
    brand: {contains: ""},
    model: {contains: ""},
    storage_capacity: {contains: ""},
    telephone_company: {contains: ""},
    status:{contains: ""},
    imei:{contains: ""},
    imei2:{contains: ""},
    serial_number:{contains: ""}
  };
  onlyNotLabeled: boolean = false;
  notLabeledList: boolean = false;
  filtersRepurchase;
  filtersPurchase;
  filtersConsignment;

  constructor(private productService: ProductService, private route: ActivatedRoute, private router: Router, private purchaseProductService:PurchaseProductService,
    private repurchaseProductService: RepurchaseProductService, private consignmentProductService:ConsignmentProductService) { }

  ngOnInit() {
    if (this.route.url['_value'][1].path.includes("listtolabel")){
      this.onlyNotLabeled = true;
      this.notLabeledList = true;
    }
    this.getProducts();
  }

  getNameProductType(type){
    var productType= ["Móviles y Tablets","Consolas","Artículos Varios","PC's-portátiles"];
    return productType[type-1];
  }
  getProducts(){
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (this.onlyNotLabeled){
      params.where.labeledproduct_id = null
    }
    if (this.notLabeledList){
      this.productService.productsToLabel(params)
      .subscribe((products) => {
          this.products = products;
          let countParams = {
            where: _.cloneDeep(params.where),
          };
          this.productService.productsToLabelCount(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
          });
      });
    }else{
      this.productService.query(params)
      .subscribe((products) => {
          this.products = products;
          let countParams = {
            where: _.cloneDeep(params.where),
          };
          this.productService.count(countParams)
          .subscribe((count) => {
            this.totalItems = count.count;
          });
      });
    }
    
  }


  getProductByEntity(){
    if (this.filtersRepurchase && this.filtersRepurchase != ""){
      this.getRepurchasesProducts(this.filtersRepurchase);
    }else if (this.filtersPurchase && this.filtersPurchase != ""){
      this.getPurchaseProducts(this.filtersPurchase);
    }else if (this.filtersConsignment && this.filtersConsignment != ""){
      this.getConsignmentProducts(this.filtersConsignment);
    }else{
      this.getProducts();
    }
  }

  getRepurchasesProducts(repurchase_id){
    let params = {
      where: {
        repurchase_id: repurchase_id
      }
    }
    this.repurchaseProductService.query(params)
    .subscribe((repurchaseProducts) => {
      let products = [];
      if (repurchaseProducts[0] && repurchaseProducts[0].repurchase && repurchaseProducts[0].repurchase.status == "Sacado a la venta"){
        repurchaseProducts.forEach(function (product){
          if (!product.product.labeledproduct_id){
            products.push(product.product);
          }
        });
      }
      this.products = products;
      this.totalItems = repurchaseProducts.length;
    });
  }

  getPurchaseProducts(purchase_id){
    let params = {
      where: {
        purchase_id: purchase_id
      }
    }
    this.purchaseProductService.query(params)
    .subscribe((purchaseProducts) => {
      let products = [];
      purchaseProducts.forEach(function (product){
        if (!product.product.labeledproduct_id){
          products.push(product.product);
        }
      });
      this.products = products;
      this.totalItems = purchaseProducts.length;
    });
  }

  getConsignmentProducts(consignment_id){
    let params = {
      where: {
        consignment_id: consignment_id
      }
    }
    
    this.consignmentProductService.query(params)
    .subscribe((consignmentProducts) => {
      let products = [];
      consignmentProducts.forEach(function (product){
        if (!product.product.labeledproduct_id){
          products.push(product.product);
        }
      });
      this.products = products;
      this.totalItems = consignmentProducts.length;
    });
  }
  
}






// WEBPACK FOOTER //
// ./src/app/products/components/list-product/list-product.component.ts